module.exports = __webpack_public_path__ + "assets/a440d677046ce0c4239c01e858413f30.png";